import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  // 👇 设置 base 为 '/GlassMax/'
  history: createWebHistory('/'),
  routes: [
    { path: '/', name: 'Home', component: () => import('@/views/HomeView.vue') },
    { path:'/product/rondot', name:'Rondot',component:()=>import('@/views/Rondot.vue') },
    {
      path: '/footprints',
      name: 'Footprints',
      component: () => import('@/views/FootprintsView.vue')
    },    
    { path:'/product/thermocouples', name:'Thermocouples',component:()=>import('@/views/Thermocouples.vue') },
    { path:'/product/glassmould', name:'GlassMould',component:()=>import('@/views/GlassMould.vue') },
    { path: '/products', name: 'ProductView', component: () => import('@/views/ProductView.vue') },
    { path: '/product/deflectors', name: 'ProductDeflectors', component: () => import('@/views/ProductDeflectors.vue') },
    { path: '/product/troughs', name: 'ProductTroughs', component: () => import('@/views/ProductTroughs.vue') },
    { path: '/product/scoops', name: 'ProductScoops', component: () => import('@/views/ProductScoops.vue') },
    { path: '/product/spareparts', name: 'ProductSpareParts', component: () => import('@/views/ProductSpareparts.vue') },
    { path: '/product/silent-chains', name: 'ProductSilentChains', component: () => import('@/views/ProductSilentChains.vue') },
    { path: '/product/cartridge-valve', name: 'ProductCartridgeValve', component: () => import('@/views/ProductCartridgeValve.vue') },
    { path: '/inspection', name: 'Inspection', component: () => import('@/views/InspectionView.vue') },
    { path: '/coating', name: 'Coating', component: () => import('@/views/CoatingView.vue') },
    { path: '/about', name: 'About', component: () => import('@/views/AboutView.vue') }
  ]
})

export default router
